// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1WRPJ","inputWrap":"CustomTip_inputWrap__3WIh1"};